import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { actions as userActions } from '../../../redux/modules/usuario';

class Logout extends PureComponent {

    componentWillMount() {
        this.props.updateUserStore({});
        this.props.removeUserStore({});

        window.close();
    }

    render() {
        return <></>;
    }
}

const mapDispatchToProps = {
    updateUserStore: userActions.updateUserStore,
    removeUserStore: userActions.removeUserStore
};


export default connect(null, mapDispatchToProps) (Logout);

